/**
 * @generated SignedSource<<8aa2193c766000786265189e811283e7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useRemoveNegotiationTest_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useGetEstimatedValueRange_item">;
  readonly " $fragmentType": "useRemoveNegotiationTest_item";
};
export type useRemoveNegotiationTest_item$key = {
  readonly " $data"?: useRemoveNegotiationTest_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"useRemoveNegotiationTest_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useRemoveNegotiationTest_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetEstimatedValueRange_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "db5d7245ab4dfbb2b91de48acfa1bc6c";

export default node;
